(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("playkit-js-hotspots", [], factory);
	else if(typeof exports === 'object')
		exports["playkit-js-hotspots"] = factory();
	else
		root["KalturaPlayer"] = root["KalturaPlayer"] || {}, root["KalturaPlayer"]["plugins"] = root["KalturaPlayer"]["plugins"] || {}, root["KalturaPlayer"]["plugins"]["playkit-js-hotspots"] = factory();
})(window, function() {
return 